import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles(() => ({
  navMenu: {
    background: "#fff",
    position: "absolute",
    top: "15%",
    left: "50%",
    "-webkit-transform": "translate(-50%, -50%)",
    transform: "translate(-50%, -50%)",
  },
  menu: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "#808080",
    fontSize: "1.2em",
    textDecoration: "none",
    textTransform: "uppercase",
    display: "inline-block",
    width: "100px",
    "-webkit-transition": "all 0.2s ease-in-out",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      color: "#fddb3a",
      cursor: "pointer",
    },
  },
}));

const ContractNavbar = ({ selected }) => {
  const { navMenu, menu } = useStyles();
  const [isMint,setIsMint] = useState(false);
 
  function handleClick(isNft) {
    selected(isNft);
  }

  if(isMint){
    return <Redirect to={"/app/mintnft"} />;
  }
  return (
    <div>
      <nav className={navMenu}>
        <div
          onClick={() => {
            handleClick(false);
          }}
          className={menu}
        >
          Token
        </div>
        <div
          onClick={() => {
            handleClick(true);
          }}
          className={menu}
        >
          NFT
        </div>
        <div
          onClick={() => {
           setIsMint(true);
          }}
          className={menu}
        >
          MINT NFT
        </div>
      </nav>
    </div>
  );
};

export default ContractNavbar;
